import TargetsProduct from './TargetsProductController';

export default TargetsProduct;
